/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { callabo__models__audit__Device } from './callabo__models__audit__Device';
import type { Geo } from './Geo';

/**
 * 레코드 내보내기 audit log
 */
export type AuditLogRecordExport = {
  ts: string;
  workspace_id: number;
  user_id?: number | null;
  system_actor?: boolean | null;
  ip?: string | null;
  device: callabo__models__audit__Device;
  geo?: Geo | null;
  user_agent?: string | null;
  action: AuditLogRecordExport.action;
  record_id: number;
  slack_channel_id?: string | null;
  integration_id?: number | null;
  to_addresses?: Array<string> | null;
  /**
   * 하위 클래스에서 구현해야 하는 action type
   */
  readonly action_type: string;
};

export namespace AuditLogRecordExport {
  export enum action {
    RECORD_EXPORT_SLACK = 'record.export.slack',
    RECORD_EXPORT_SALESFORCE = 'record.export.salesforce',
    RECORD_EXPORT_PIPEDRIVE = 'record.export.pipedrive',
    RECORD_EXPORT_NOTION = 'record.export.notion',
    RECORD_EXPORT_EMAIL = 'record.export.email',
    RECORD_EXPORT_MS_TEAMS = 'record.export.ms-teams',
    RECORD_EXPORT_LINEAR = 'record.export.linear',
    RECORD_EXPORT_CONFLUENCE = 'record.export.confluence',
  }
}
